import { Store } from '../../store/store.model';
import { FirebaseObject } from './firebase-token.types';
export const firebaseTokenSelector = (store: Store): FirebaseObject | null =>
  store?.firebaseToken ?? null;
